import React from "react";
import { useNavigate } from "react-router-dom";

const PagesError404 = () => {
  const navigate = useNavigate();
  return (
    <div className="flex-container">
      <div className="text-center">
        <h1>
          <span className="fade-in" id="digit1">
            4
          </span>
          <span className="fade-in" id="digit2">
            0
          </span>
          <span className="fade-in" id="digit3">
            4
          </span>
        </h1>
        <h3 className="fadeIn">Page non trouvée</h3>
        <button type="button" onClick={() => navigate(-1)} name="button">
          Retourner à la page d'accueil
        </button>
      </div>
    </div>
  );
};

export default PagesError404;
